import { format } from 'date-fns/format';
import { AnnualTamPrimeAggregate, MonthlyTamPrimeQueryResult } from '../types/primes';
import { mapAnnualRowToMonthlyTamPrimeQueryResult, mapAnnualTamPrimeToTableRows } from './annualPrime.utils';

export const buildAnnualTamPrimesCacheKey = (tamEmail: string, year: string): string =>
  `${tamEmail.trim().toLowerCase()}::${year}`;

export const deriveMonthlyTamPrimeFromAnnualAggregate = (
  aggregate: AnnualTamPrimeAggregate,
  referenceDate: Date,
): MonthlyTamPrimeQueryResult | undefined => {
  const monthYear = format(referenceDate, 'MM/yyyy');
  const row = mapAnnualTamPrimeToTableRows(aggregate).find((candidate) => candidate.monthYear === monthYear);

  if (row === undefined) {
    return undefined;
  }

  return mapAnnualRowToMonthlyTamPrimeQueryResult(aggregate, row);
};
